import { InternAudioMetaEpisode } from '../intern/audio-meta-episode';
import { InternAudioMetaPodcast } from '../intern/audio-meta-podcast';

/**
 * Model definition for Audio
 */
export interface ContentAudio {
  __component: 'content.audio';
  id: string;
  podcastId: string;
  episodeId?: string;
  metaPodcast?: InternAudioMetaPodcast;
  metaEpisode?: InternAudioMetaEpisode;
}

export function isContentAudio(obj: { __component?: string }): obj is ContentAudio {
  return obj.__component === 'content.audio';
}
